import { render } from "./DDropdownItem.vue?vue&type=template&id=0b27a981&scoped=true"
import script from "./DDropdownItem.vue?vue&type=script&lang=js"
export * from "./DDropdownItem.vue?vue&type=script&lang=js"

import "./DDropdownItem.vue?vue&type=style&index=0&id=0b27a981&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b27a981"]])

export default __exports__